import {defaultBreadcrumbs, ScreenProp} from 'src/app/models'

export const DepartemenScreen: Record<string, ScreenProp> = {
  DEPARTEMEN_LIST: {
    PATH: '/administration/setup-departemen',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    breadcrumbs: defaultBreadcrumbs,
  },
  DEPARTEMEN_ADD: {
    PATH: '/administration/setup-departemen/add',
    TITLE: 'Buat Departemen',
    TITLE_ALT: 'Buat Departemen',
    breadcrumbs: defaultBreadcrumbs,
  },
  DEPARTEMEN_EDIT: {
    PATH: '/administration/setup-departemen/edit/:id',
    TITLE: 'Edit Departemen',
    TITLE_ALT: 'Edit Departemen',
    breadcrumbs: defaultBreadcrumbs,
  },
  DEPARTEMEN_DETAIL: {
    PATH: '/administration/setup-departemen/detail/:id',
    TITLE: 'Detail Departemen',
    TITLE_ALT: 'Detail Departemen',
    breadcrumbs: defaultBreadcrumbs,
  },
}
